import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';

// components
import Header from '../../components/Header/Header';
import Navbar from '../../components/Navbar/Navbar';
import Breadcrumbs from '../../components/Breadcrumbs';

// icons
import leads from '../../brand/generated/sidebar/leads.svg';

const LeadsNavigation = () => {
  const { id } = useParams();
  const items = [
    { text: 'ÐÑÐ½Ð¾Ð²Ð½Ð°Ñ Ð¸Ð½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ', navigate: id ? `/leads/lead/${id}/main-info` : '/leads/create' },
    { text: 'ÐÐ»Ð¸ÐµÐ½Ñ', navigate: id ? `/leads/lead/${id}/client` : '/leads/client' },
  ];
  if (id) {
    items.push({ text: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¸ Ð±Ð°Ð½ÐºÐ¸', navigate: `/leads/lead/${id}/deal-info` });
  }

  return (
    <>
      <Header title={id ? `ÐÐ¸Ð´ - ID ${id}` : 'ÐÐ¾Ð²ÑÐ¹ Ð»Ð¸Ð´'} icon={leads} />
      <Breadcrumbs navigate={'/leads'} link={'ÐÐ¸Ð´Ñ'} currentPage={id ? `ÐÐ¸Ð´ - ID ${id}` : 'ÐÐ¸Ð´Ñ'} />
      <Navbar items={items} />
      <Outlet />
    </>
  );
};

export default LeadsNavigation;
